import { render, staticRenderFns } from "./DataIterator.vue?vue&type=template&id=7d0724b8&"
import script from "./DataIterator.vue?vue&type=script&lang=js&"
export * from "./DataIterator.vue?vue&type=script&lang=js&"
import style0 from "./DataIterator.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VPagination})
